/**
 *
 */

export default class OptimizeTest {
  readonly id: string

  readonly expiration: number

  readonly variant: string

  constructor(id, expiration = Number.POSITIVE_INFINITY, variant = '0') {
    if (!id) {
      throw new Error('An OptimizeTest cannot be initialized without an ID.')
    }

    this.id = id
    this.expiration = expiration
    this.variant = variant.trim() === '' ? '0' : variant
  }
}
